import { useFormContext } from 'react-hook-form';

import { useFetchRecruiterSMTPAccounts } from '../../../components/BulkEmail/helper/apiCalls';
import { WsAsyncAutocomplete } from '../../../components/WsAsyncAutocomplete';

interface SMTPEmailFilterProps {
  name: string;
  disable?: boolean;
  multiple?: boolean;
  placeHolder?: string;
}

const SMTPEmailFilter = ({
  name,
  disable = false,
  multiple = false,
  placeHolder = '',
}: SMTPEmailFilterProps) => {
  const methods = useFormContext();
  const accountData = useFetchRecruiterSMTPAccounts();
  const onSearch = async (searchText: string) => {
    if (accountData?.data) {
      const selected = methods.getValues(name) ?? [];
      const options = accountData.data
        .filter((account) => searchText && account?.fromEmail.includes(searchText))
        .filter(
          (account) =>
            !selected.some((selectedAccount) => selectedAccount.fromEmail === account.fromEmail)
        )
        .map((account) => ({
          ...account,
          label: account.fromEmail,
        }));
      return options;
    }
    return [];
  };
  return (
    <WsAsyncAutocomplete
      name={name}
      getOptions={onSearch}
      multiple={multiple}
      placeholder={placeHolder}
      creatable={false}
      onCreate={() => {}}
      required={true}
      disable={disable}
    />
  );
};

export default SMTPEmailFilter;
